import React from 'react';
import { BodyObject, ComponentType } from '@/types/api';
import { Box } from '../../wag-react/next-components/box';
import { OL } from '../../wag-react/core-components/ol';
import { LI } from '../../wag-react/core-components/li';
import { Button } from '../../wag-react/next-components/button';
export type OverviewBlockProps = {
  value: Extract<BodyObject, {
    type: Extract<ComponentType<React.PropsWithChildren<unknown>>, 'overview'>;
  }>['value'];
};
export const OverviewBlock = ({
  value
}: OverviewBlockProps) => <Box py={[2, 3]} px={[1, 3]} my={3} backgroundColor="#F5F5F5" data-sentry-element="Box" data-sentry-component="OverviewBlock" data-sentry-source-file="index.tsx">
    <OL display="grid" gridGap="16px" data-sentry-element="OL" data-sentry-source-file="index.tsx">
      {value.map(({
      id,
      value: title
    }) => <LI key={id} fontSize={['16px', '18px']} fontWeight={800} color="wagGreen" pl="16px">
          <Button href={id} fontSize="inherit" fontWeight="inherit" color="inherit" minWidth="auto">
            {title}
          </Button>
        </LI>)}
    </OL>
  </Box>;